import React from 'react';

const GridCell = ({ dataItem, node, chartClick, measure, field }) => {
  return (
    <td>
      {field && (
        <div className="cashflow-cell" onClick={(e) => chartClick(e, dataItem, node, measure, field)}>
          {dataItem[field]}
        </div>
      )}
    </td>
  );
};

export default GridCell;
